import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const HomeBoxContainer = styled(Box)``;
